export default function NotFoundPage() {
  const handleGoHome = () => {
    window.location.href = "/"
  }

  const styles = {
    container: {
      minHeight: "100vh",
      backgroundColor: "#f9fafb",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "0 1rem",
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    },
    content: {
      textAlign: "center",
      maxWidth: "600px",
    },
    title: {
      fontSize: "8rem",
      fontWeight: "bold",
      color: "#1f2937",
      margin: "0 0 1rem 0",
      lineHeight: "1",
    },
    heading: {
      fontSize: "2.5rem",
      fontWeight: "600",
      color: "#374151",
      margin: "0 0 1rem 0",
      lineHeight: "1.2",
    },
    description: {
      fontSize: "1.125rem",
      color: "#6b7280",
      margin: "0 0 2rem 0",
      lineHeight: "1.6",
      maxWidth: "400px",
      marginLeft: "auto",
      marginRight: "auto",
    }
  }

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        {/* Número 404 grande */}
        <h1 style={styles.title}>404</h1>

        {/* Mensaje principal */}
        <h2 style={styles.heading}>Página no encontrada</h2>

        {/* Descripción */}
        <p style={styles.description}>Lo sentimos, la página que estás buscando no existe o ha sido movida.</p>
      </div>
    </div>
  )
}
